<mat-card>
  <app-card-header
    [title]="'Detalles de auditoría'"
    [subtitle]="data.entidad"
    icono="history"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-content-card title="Registro" icon="info">
      <div class="aud-datos">
        <span class="aud-etiqueta">Fecha</span>
        <span class="aud-valor">
          {{ data.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
        </span>

        <span class="aud-etiqueta">Usuario</span>
        @if (data.nombreUsuario) {
          <span class="aud-valor">{{ data.nombreUsuario }}</span>
        } @else {
          <span class="no-info">Sin usuario</span>
        }

        <span class="aud-etiqueta">Entidad</span>
        @if (data.entidad) {
          <span class="aud-valor">{{ data.entidad }}</span>
        } @else {
          <span class="no-info">Sin entidad</span>
        }

        <span class="aud-etiqueta">ID entidad</span>
        @if (data.idEntidad) {
          <span class="aud-valor aud-mono">{{ data.idEntidad }}</span>
        } @else {
          <span class="no-info">Sin ID</span>
        }

        <span class="aud-etiqueta">Acción</span>
        @if (data.accion) {
          <span class="aud-valor">{{ data.accion }}</span>
        } @else {
          <span class="no-info">Sin acción</span>
        }
      </div>
    </app-content-card>

    @if (data.accion === 'Editar' && data.valoresAnteriores) {
      <app-content-card title="Cambios" icon="compare_arrows">
        <table class="aud-diff">
          <thead>
            <tr>
              <th>Campo</th>
              <th>Antes</th>
              <th>Después</th>
            </tr>
          </thead>
          <tbody>
            @for (campo of camposEditados; track campo) {
              <tr>
                <td class="aud-campo">{{ campo }}</td>
                <td class="aud-antes">
                  {{ data.valoresAnteriores?.[campo] | json }}
                </td>
                <td class="aud-despues">
                  {{ data.cambios?.[campo] | json }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-content-card>
    } @else if (data.accion === 'Eliminar' && data.valoresAnteriores) {
      <app-content-card title="Documento eliminado" icon="delete_outline">
        <pre class="aud-json">{{ data.valoresAnteriores | json }}</pre>
      </app-content-card>
    } @else if (data.cambios) {
      <app-content-card title="Cambios" icon="compare_arrows">
        <pre class="aud-json">{{ data.cambios | json }}</pre>
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
  </mat-card-actions>
</mat-card>
